import * as THREE from 'three'

export default class VRIconographyMenu {

  constructor(options = {}) {

    this.scene = options.scene
    this.camera = options.camera
    this.interactiveGroup = options.interactiveGroup

    this.onSelect = options.onSelect || function () {}
    this.onOpen = options.onOpen || function () {}
    this.onClose = options.onClose || function () {}

    this.pageSize = 8

    this.rootNodes = []
    this.path = []
    this.page = 0

    this.selected = []

    this.width = 0.36
    this.height = 0.30

    this.canvasWidth = 900
    this.canvasHeight = 750

    this.canvas = document.createElement('canvas')
    this.canvas.width = this.canvasWidth
    this.canvas.height = this.canvasHeight

    this.ctx = this.canvas.getContext('2d')

    this.texture = new THREE.CanvasTexture(this.canvas)
    this.texture.colorSpace = THREE.SRGBColorSpace

    this.material = new THREE.MeshBasicMaterial({
      map: this.texture,
      transparent: true
    })

    this.geometry = new THREE.PlaneGeometry(
      this.width,
      this.height
    )

    this.mesh = new THREE.Mesh(
      this.geometry,
      this.material
    )

    this.mesh.userData.vrMenu = true

    this.buttonMeshes = []

    this.mesh.addEventListener('mousedown', (event) => {
      this.handlePress(event.data)   // Vector2, x: 0..1, y: 0..1 von oben
    })

    this.visible = false

    this.redraw()
  }


  // ------------------------------------------------------------
  // DATA
  // ------------------------------------------------------------
  canvasToLocal(x, y) {

    return {
      x: (x / this.canvasWidth - 0.5) * this.width,
      y: (0.5 - y / this.canvasHeight) * this.height
    }
  }
  setNodes(nodes) {

    this.rootNodes = nodes || []

    this.path = []
    this.page = 0

    this.redraw()
  }


  setSelected(selected) {

    this.selected = selected || []

    this.redraw()
  }


  // ------------------------------------------------------------
  // CURRENT TREE LEVEL
  // ------------------------------------------------------------

  getCurrentNodes() {

    let nodes = this.rootNodes

    for (const id of this.path) {

      const node = nodes.find(n => n.id === id)

      if (!node) {
        return []
      }

      nodes = node.children || []
    }

    return nodes
  }


  getCurrentParent() {

    if (this.path.length === 0) {
      return null
    }

    let nodes = this.rootNodes
    let node = null

    for (const id of this.path) {

      node = nodes.find(n => n.id === id)

      if (!node) {
        return null
      }

      nodes = node.children || []
    }

    return node
  }


  getPageCount() {

    return Math.max(
      1,
      Math.ceil(
        this.getCurrentNodes().length / this.pageSize
      )
    )
  }


  getVisibleNodes() {

    const nodes = this.getCurrentNodes()

    const start = this.page * this.pageSize

    return nodes.slice(
      start,
      start + this.pageSize
    )
  }


  // ------------------------------------------------------------
  // NAVIGATION
  // ------------------------------------------------------------

openNode(node) {

  if (!node.children || node.children.length === 0) {
    return
  }

  this.path.push(node.id)
  this.page = 0

  this.redraw()

  this.onOpen(node)
}

  back() {

    if (this.path.length === 0) {
      return
    }

    this.path.pop()
    this.page = 0

    this.redraw()
  }


  nextPage() {

    const pageCount = this.getPageCount()

    if (this.page < pageCount - 1) {

      this.page++

      this.redraw()
    }
  }


  previousPage() {

    if (this.page > 0) {

      this.page--

      this.redraw()
    }
  }


getLeafNodes(node) {

  if (!node.children || node.children.length === 0) {
    return [node]
  }

  let leaves = []

  for (const child of node.children) {
    leaves = leaves.concat(
      this.getLeafNodes(child)
    )
  }

  return leaves
}


toggleSelection(node) {

  const leaves = this.getLeafNodes(node)

  if (leaves.length === 0) {
    return
  }

  const allSelected = leaves.every(
    leaf => this.isSelected(leaf)
  )

  let newSelection

  if (allSelected) {

    // Alle Blätter dieses Astes entfernen
    const ids = new Set(
      leaves.map(leaf => leaf.id)
    )

    newSelection = this.selected.filter(
      item => !ids.has(item.id)
    )

  } else {

    // Alle Blätter dieses Astes hinzufügen
    const existingIds = new Set(
      this.selected.map(item => item.id)
    )

    newSelection = [
      ...this.selected,
      ...leaves.filter(
        leaf => !existingIds.has(leaf.id)
      )
    ]
  }

  this.selected = newSelection

  this.redraw()

  this.onSelect(newSelection)
}


isSelected(node) {

  return this.selected.some(
    item => item.id === node.id
  )
}


isPartiallySelected(node) {

  const leaves = this.getLeafNodes(node)

  if (leaves.length === 0) {
    return false
  }

  const selectedCount =
    leaves.filter(
      leaf => this.isSelected(leaf)
    ).length

  return (
    selectedCount > 0 &&
    selectedCount < leaves.length
  )
}


isFullySelected(node) {

  const leaves = this.getLeafNodes(node)

  return (
    leaves.length > 0 &&
    leaves.every(
      leaf => this.isSelected(leaf)
    )
  )
}

  isSelected(node) {

    return this.selected.some(
      item => item.id === node.id
    )
  }

  handlePress(uv) {
  if (!this.visible || !uv) return

  const x = uv.x * this.canvasWidth
  const y = uv.y * this.canvasHeight

  // Pagination (unten)
  if (y > this.canvasHeight - 85) {
    if (x < 200) this.previousPage()
    else if (x > this.canvasWidth - 200) this.nextPage()
    return
  }

  // Zurück (Pfadzeile)
  if (this.path.length > 0 && y > 70 && y < 115 && x < 450) {
    console.log("back")
    this.back()
    return
  }

  // Zeilen: exakt dieselbe Rechnung wie in redraw()
  const rowStartY = this.getCurrentParent() ? 135 : 105
  const index = Math.floor((y - (rowStartY - 27)) / 55)

  const node = this.getVisibleNodes()[index]
  if (index >= 0 && node) this.openNode(node)
}

  // ------------------------------------------------------------
  // BUTTONS
  // ------------------------------------------------------------



nodeId(n) {
  return n.iconographyID ?? n.id
}

openNode(node) {
  if (!node.children || node.children.length === 0) return

  this.path.push(this.nodeId(node))
  this.page = 0
  this.redraw()
  this.onOpen(node)
}

back() {
  if (this.path.length === 0) return
  this.path.pop()
  this.page = 0
  this.redraw()
}

getCurrentNodes() {
  let nodes = this.rootNodes
  for (const id of this.path) {
    const node = nodes.find(n => this.nodeId(n) === id)
    if (!node) return []
    nodes = node.children || []
  }
  return nodes
}

getCurrentParent() {
  if (this.path.length === 0) return null
  let nodes = this.rootNodes
  let node = null
  for (const id of this.path) {
    node = nodes.find(n => this.nodeId(n) === id)
    if (!node) return null
    nodes = node.children || []
  }
  return node
}

toggleSelection(node) {
  const leaves = this.getLeafNodes(node)
  if (leaves.length === 0) return

  const ids = new Set(leaves.map(l => this.nodeId(l)))
  const allSelected = leaves.every(l => this.isSelected(l))

  if (allSelected) {
    this.selected = this.selected.filter(s => !ids.has(this.nodeId(s)))
  } else {
    const existing = new Set(this.selected.map(s => this.nodeId(s)))
    this.selected = [
      ...this.selected,
      ...leaves.filter(l => !existing.has(this.nodeId(l)))
    ]
  }

  this.redraw()
  this.onSelect(this.selected)
}

isSelected(node) {
  return this.selected.some(s => this.nodeId(s) === this.nodeId(node))
}

handlePress(uv) {
  if (!this.visible || !uv) return

  const x = uv.x * this.canvasWidth
  const y = uv.y * this.canvasHeight

  // Pagination
  if (y > this.canvasHeight - 85) {
    if (x < 200) this.previousPage()
    else if (x > this.canvasWidth - 200) this.nextPage()
    return
  }

  // Zurück
  if (this.path.length > 0 && y > 70 && y < 108 && x < 450) {
    this.back()
    return
  }

  // Zeile bestimmen
  const rowStartY = this.getCurrentParent() ? 135 : 105
  const index = Math.floor((y - (rowStartY - 27)) / 55)
  const node = this.getVisibleNodes()[index]
  if (index < 0 || !node) return

  const hasChildren = node.children && node.children.length > 0

  if (!hasChildren) {
    // Blatt: ganze Zeile toggelt (großes Ziel, in VR besser zu treffen)
    this.toggleSelection(node)
    return
  }

  // Ast: Checkbox-Zone (x 65..105) wählt aus, der Rest der Zeile öffnet
  if (x >= 65 && x < 105) this.toggleSelection(node)
  else this.openNode(node)
}









  // ------------------------------------------------------------
  // DRAW
  // ------------------------------------------------------------

  redraw() {

    const ctx = this.ctx

    const w = this.canvasWidth
    const h = this.canvasHeight

    ctx.clearRect(
      0,
      0,
      w,
      h
    )


    // ----------------------------------------------------------
    // BACKGROUND
    // ----------------------------------------------------------

    ctx.fillStyle =
      'rgba(20,20,20,0.94)'

    this.roundRect(
      ctx,
      5,
      5,
      w - 10,
      h - 10,
      25
    )

    ctx.fill()


    // ----------------------------------------------------------
    // HEADER
    // ----------------------------------------------------------

    ctx.fillStyle = '#ffffff'

    ctx.font =
      'bold 42px Arial'

    ctx.textBaseline =
      'middle'

    ctx.fillText(
      'ICONOGRAPHY',
      45,
      50
    )


    // ----------------------------------------------------------
    // PATH
    // ----------------------------------------------------------

    const parent =
      this.getCurrentParent()

    if (parent) {

      ctx.font =
        '28px Arial'

      ctx.fillStyle =
        '#bbbbbb'

      ctx.fillText(
        '< ' + this.truncate(
          parent.name,
          32
        ),
        45,
        92
      )
    }


    // ----------------------------------------------------------
    // ROWS
    // ----------------------------------------------------------

    const nodes =
      this.getVisibleNodes()

    const rowStartY =
      parent ? 135 : 105

    const rowHeight =
      55

    nodes.forEach(
      (node, index) => {

        const y =
          rowStartY +
          index * rowHeight


        // Row background

        ctx.fillStyle =
          'rgba(255,255,255,0.08)'

        this.roundRect(
          ctx,
          30,
          y - 23,
          w - 60,
          48,
          8
        )

        ctx.fill()


        // Selection

        if (this.isSelected(node)) {

          ctx.strokeStyle =
            '#ffffff'

          ctx.lineWidth =
            3

          this.roundRect(
            ctx,
            30,
            y - 23,
            w - 60,
            48,
            8
          )

          ctx.stroke()
        }


        // Arrow / checkbox

// ----------------------------------------------------------
// ARROW
// ----------------------------------------------------------

const hasChildren =
  node.children &&
  node.children.length > 0

if (hasChildren) {

  ctx.fillStyle = '#ffffff'
  ctx.font = '26px Arial'
  ctx.textAlign = 'center'

  ctx.fillText(
    '▶',
    48,
    y
  )

  ctx.textAlign = 'left'
}


// ----------------------------------------------------------
// CHECKBOX
// ----------------------------------------------------------

const checkboxX =
  hasChildren ? 68 : 48

const fullySelected =
  this.isFullySelected(node)

const partiallySelected =
  this.isPartiallySelected(node)

ctx.strokeStyle = '#ffffff'
ctx.lineWidth = 2

ctx.strokeRect(
  checkboxX,
  y - 11,
  22,
  22
)

if (fullySelected) {

  ctx.fillStyle = '#ffffff'

  ctx.fillRect(
    checkboxX + 4,
    y - 7,
    14,
    14
  )

} else if (partiallySelected) {

  ctx.fillStyle = '#ffffff'

  ctx.fillRect(
    checkboxX + 5,
    y - 2,
    12,
    4
  )
}


        // Name

        ctx.fillStyle =
          '#ffffff'

        ctx.font =
          '28px Arial'

ctx.fillText(
  this.truncate(
    node.name,
    29
  ),
  hasChildren ? 105 : 85,
  y
)


        // Count

        const count =
          node.annotationCount !== undefined
            ? node.annotationCount
            : node.count !== undefined
              ? node.count
              : 0

        ctx.font =
          '25px Arial'

        ctx.fillStyle =
          '#bbbbbb'

        const countText =
          String(count)

        const countWidth =
          ctx.measureText(countText).width

        ctx.fillText(
          countText,
          w - 45 - countWidth,
          y
        )
      }
    )


    // ----------------------------------------------------------
    // PAGINATION
    // ----------------------------------------------------------

    const pageCount =
      this.getPageCount()

    const total =
      this.getCurrentNodes().length

    const first =
      total === 0
        ? 0
        : this.page * this.pageSize + 1

    const last =
      Math.min(
        (this.page + 1) * this.pageSize,
        total
      )


    ctx.font =
      'bold 28px Arial'

    ctx.fillStyle =
      '#ffffff'

    ctx.textAlign =
      'center'

    ctx.fillText(
      `${first}–${last} / ${total}`,
      w / 2,
      h - 45
    )


    ctx.font =
      'bold 42px Arial'

    ctx.fillText(
      '‹',
      95,
      h - 45
    )

    ctx.fillText(
      '›',
      w - 95,
      h - 45
    )

    ctx.textAlign =
      'left'


    // ----------------------------------------------------------
    // TEXTURE UPDATE
    // ----------------------------------------------------------

    this.texture.needsUpdate = true
  }


  // ------------------------------------------------------------
  // POSITION
  // ------------------------------------------------------------

  attachToController(
    controller,
    distance = 0.35
  ) {

    const position =
      new THREE.Vector3()

    const quaternion =
      new THREE.Quaternion()

    controller.getWorldPosition(
      position
    )

    controller.getWorldQuaternion(
      quaternion
    )

    this.mesh.position.copy(
      position
    )

    const forward =
      new THREE.Vector3(
        0,
        0,
        -distance
      )

    forward.applyQuaternion(
      quaternion
    )

    this.mesh.position.add(
      forward
    )

    this.mesh.setRotationFromQuaternion(
      quaternion
    )
  }


  // ------------------------------------------------------------
  // VISIBILITY
  // ------------------------------------------------------------

  show() {

    this.mesh.visible = true
    this.visible = true
  }


  hide() {

    this.mesh.visible = false
    this.visible = false
  }


  dispose() {

    this.mesh.removeFromParent()

    this.geometry.dispose()
    this.material.dispose()
    this.texture.dispose()

    for (const button of this.buttonMeshes) {

      if (button.geometry) {
        button.geometry.dispose()
      }

      if (button.material) {
        button.material.dispose()
      }
    }
  }


  // ------------------------------------------------------------
  // HELPERS
  // ------------------------------------------------------------

  truncate(text, maxLength) {

    if (!text) {
      return ''
    }

    if (text.length <= maxLength) {
      return text
    }

    return text.substring(
      0,
      maxLength - 1
    ) + '…'
  }


  roundRect(
    ctx,
    x,
    y,
    width,
    height,
    radius
  ) {

    ctx.beginPath()

    ctx.moveTo(
      x + radius,
      y
    )

    ctx.lineTo(
      x + width - radius,
      y
    )

    ctx.quadraticCurveTo(
      x + width,
      y,
      x + width,
      y + radius
    )

    ctx.lineTo(
      x + width,
      y + height - radius
    )

    ctx.quadraticCurveTo(
      x + width,
      y + height,
      x + width - radius,
      y + height
    )

    ctx.lineTo(
      x + radius,
      y + height
    )

    ctx.quadraticCurveTo(
      x,
      y + height,
      x,
      y + height - radius
    )

    ctx.lineTo(
      x,
      y + radius
    )

    ctx.quadraticCurveTo(
      x,
      y,
      x + radius,
      y
    )

    ctx.closePath()
  }
}